/**
 * Product Form Intersection Observer
 * Detecta cuando el product-form está fuera del viewport y añade la clase is-fixed
 */
class ProductFormIntersection {
  constructor() {
    this.productForms = [];
    this.observers = [];
    this.mutationObserver = null;
    this.init();
  }

  init() {
    // Buscar todos los product-forms en la página
    this.productForms = document.querySelectorAll('.product-form');
    this.gorgiasChat = document.getElementById('gorgias-chat-container')
    this.backToTop = document.querySelector('back-to-top')
    
    if (this.productForms.length === 0) {
      return;
    }
    this.observeGorgiasContainer();
    this.setupIntersectionObservers();
  }

  observeGorgiasContainer() {
    if (this.gorgiasChat) {
      return;
    }

    // Observar inserciones en el DOM para detectar cuando la app monte el contenedor de Gorgias
    this.mutationObserver = new MutationObserver(() => {
      const found = document.getElementById('gorgias-chat-container');
      if (found) {
        this.gorgiasChat = found;

        // Sincronizar visibilidad según el estado actual del product-form
        const anyFixed = Array.from(this.productForms).some((el) => el.classList.contains('is-fixed'));
        if (anyFixed) {
          this.gorgiasChat.classList.add('hidden');
        } else {
          this.gorgiasChat.classList.remove('hidden');
        }

        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
          this.mutationObserver = null;
        }
      }
    });

    // Observar todo el documento porque las apps suelen inyectar en body o shadow hosts
    this.mutationObserver.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true
    });
  }

  setupIntersectionObservers() {
    // Configurar las opciones del Intersection Observer
    const options = {
      root: null, // Usar el viewport como root
      rootMargin: '0px', // Sin margen adicional
      threshold: 0 // Disparar cuando el elemento sale completamente del viewport
    };

    // Crear un observer para cada product-form
    this.productForms.forEach((productForm, index) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // El elemento está visible en el viewport
            entry.target.classList.remove('is-fixed');

            if (this.gorgiasChat) {
              this.gorgiasChat.classList.remove('hidden')
            }

            if (this.backToTop) {
              this.backToTop.classList.remove('hidden')
            }

          } else {
            // El elemento está fuera del viewport
            entry.target.classList.add('is-fixed');

            if (this.gorgiasChat) {
              this.gorgiasChat.classList.add('hidden')
            }

            if (this.backToTop) {
              this.backToTop.classList.add('hidden')
            }
          }
        });
      }, options);

      // Observar el product-form
      observer.observe(productForm);
      this.observers.push(observer);
    });
  }

  destroy() {
    this.observers.forEach(observer => {
      if (observer) {
        observer.disconnect();
      }
    });
    this.observers = [];
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  }
}

// Variable global para mantener la instancia
let productFormIntersectionInstance = null;

// Función para inicializar o reinicializar
function initProductFormIntersection() {
  // Destruir instancia anterior si existe
  if (productFormIntersectionInstance) {
    productFormIntersectionInstance.destroy();
  }
  
  // Crear nueva instancia
  productFormIntersectionInstance = new ProductFormIntersection();
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', initProductFormIntersection);

// También inicializar en páginas que usan instant.page
document.addEventListener('instantpage:load', initProductFormIntersection); 